// extracted by mini-css-extract-plugin
export default {"formGroup":"SelectSearch_formGroup__GwPsk","subLabel":"SelectSearch_subLabel__zEXcG"};